export enum AddressFieldNames {
  POSTCODE = 'postcode',
  CITY = 'city',
  STREET = 'street',
  STREET_ID = 'streetId',
  HOUSE_NUMBER = 'houseNumber',
}
